import React from 'react';
import { Label, Stack } from '@talentmesh/core';
import { RHFAutocompleteDropdown } from '@talentmesh/forms';
import { RecruitmentInformationSalaryExpectation } from '../../../RecruitmentInformationUtils';
import currencies from '../../../../../../../Utils/Currency/currencies';
import useTMTranslation from '../../../../../../../Hooks/useTMTranslation';

function CurrencyAutocomplete(): React.JSX.Element {
    const { tCommon } = useTMTranslation();

    return (
        <Stack flex={1}>
            <Label>{tCommon('Currency')}</Label>
            <RHFAutocompleteDropdown
                name={RecruitmentInformationSalaryExpectation.SalaryExpectationCurrency}
                data-cy={RecruitmentInformationSalaryExpectation.SalaryExpectationCurrency}
                options={currencies}
                disableErrorMessage
            />
        </Stack>
    );
}

export default CurrencyAutocomplete;
